import { redirectUriList } from '~utils/msal/redirectUriList'

const devEnv = {
  // fetch
  basePath: 'https://dev-portal-api.safholland.com',
  crudeRestPath: '/api/crude/',
  msalRedirectUri: redirectUriList.dev,
  crudeBasePath: 'https://dev-portal-api.safholland.com',
}

const localEnv = {
  ...devEnv,
  msalRedirectUri: redirectUriList.local,
  crudeBasePath: 'http://localhost:8080',
}

const stageEnv = {
  ...devEnv,

  // fetch
  basePath: 'https://stage-portal-api.safholland.com',
  crudeRestPath: '/api/crude/',
  msalRedirectUri: redirectUriList.stage,
  crudeBasePath: 'https://stage-portal-api.safholland.com',
}

const liveEnv = {
  ...stageEnv,

  // fetch
  basePath: 'https://portal-api.safholland.com',
  crudeRestPath: '/api/crude/',
  msalRedirectUri: redirectUriList.live,
  crudeBasePath: 'https://portal-api.safholland.com',
}

type Env = typeof devEnv
  | typeof localEnv
  | typeof stageEnv
  | typeof liveEnv

const getEnvValues: () => Env = () => {
  switch (process.env.BUILD_ENV) {
    case 'development':
      return devEnv
    case 'local':
      return localEnv
    case 'stage':
      return stageEnv
    case 'live':
      return liveEnv
  }

  if (process.env.NODE_ENV === 'development') {
    return devEnv
  }
  return stageEnv
}

export const isDebugEnv: boolean = process.env.BUILD_ENV !== undefined
  ? process.env.BUILD_ENV === 'development' || process.env.BUILD_ENV === 'local'
  : process.env.NODE_ENV === 'development'

export default getEnvValues()
